<template>
  <div class="AvisoPrivacidad">
    <v-dialog
      v-model="show"
      overlay-color="white"
      style="z-index:1003"
      overlay-opacity=".8"
      width="800"
      persistent
    >
      <div
        @click.stop="show=false"
        class="text-right pt-3 pr-3"
        style="position: sticky; top: 0px; right: 0px; width; z-index: 1; background-color: white;"
      >
        <v-icon style="cursor: pointer;">mdi-close</v-icon>
      </div>
      <v-card class="pb-12" tile width="100%" elevation="0" style="overflow-x:hidden;">
        <v-row justify="center">
          <!-- <v-col cols="12" class="modal-terminos-columna">
            <div class="modal-terminos-tacha" @click.stop="show=false">
              <v-icon>mdi-close</v-icon>
            </div>
          </v-col>-->
          <v-col cols="10" class="pt-6">
            <v-img src="@/assets/img/logo/logo.png" width="90" class="d-block ml-auto"></v-img>
          </v-col>
          <v-col class="text-center" cols="12">
            <span class="modal-terminos-condiciones-title">
              <b>AVISO DE PRIVACIDAD DE LASER SAN LUIS S.A. DE C.V.</b>
            </span>
          </v-col>
          <v-col cols="10">
            <p>
              <b>
                LASER SAN LUIS, S.A. DE C.V. (VISION LASER SAN LUIS), con domicilio en Av. Venustiano Carranza No. 2055,
                Col. Jardín, C.P. 78270, San Luis Potosí, S.L.P.,
              </b> es responsable del tratamiento de sus datos personales conforme a este aviso de
              privacidad. De conformidad con el artículo 17, fracción
              <b>II</b> de la Ley de Protección de Datos Personales,
              <b>VISION LASER SAN LUIS</b> le
              informa que tratará con sus datos personales para las siguientes finalidades.
            </p>

            <span class="d-block">
              <b>FINALIDAD DEL TRATAMIENTO DE LOS DATOS PERSONALES</b>
            </span>
            <span>
              Los Datos Personales en posesión de
              <b>VISION LASER SAN LUIS</b> serán utilizados para:
            </span>

            <ul>
              <li>
                Prestación de servicios médico-hospitalarios, incluyendo de manera enunciativa: hospitalización, cirugía, estudios
                diagnósticos, atención de enfermería, servicios farmacéuticos, servicios de banco de sangre, análisis de laboratorio, radiología
                e imagen, terapia, rehabilitación, dieta y nutrición y demás fines relacionados con servicios de salud.
              </li>
              <li>Creación, estudio, análisis, actualización, y conservación del expediente clínico.</li>
              <li>Facturación y cobranza por servicios.</li>
              <li>Estudios, registros, estadísticas y análisis de información de salud.</li>
              <li>
                Conservación de registros para seguimiento a servicios, prestación de servicios en el futuro y en general para dar seguimiento
                a cualquier relación contractual.
              </li>
              <li>Análisis estadísticos y de mercado.</li>
              <li>Promoción y mercadeo de productos y servicios de otras empresas pertenecientes al mismo grupo corporativo.</li>
            </ul>

            <span>
              Por lo tanto,
              <b>VISION LASER SAN LUIS</b> tratará los siguientes datos personales: nombre completo, domicilio, edad, fecha de
              nacimiento, estado civil, nacionalidad, sexo, número telefónico particular, de trabajo o de oficina, así como nombre, domicilio y número
              telefónico de algún familiar que designe como responsable y con quien podamos comunicarnos en caso de emergencia.
            </span>

            <br />
            <br />
            <span class="d-block">
              <b>DATOS SENSIBLES</b>
            </span>
            <span>
              Con la finalidad de poder brindarle el servicio y de conformidad con la legislación en materia de salud aplicable,
              <b>
                VISION LASER SAN
                LUIS
              </b> recabará y tratará datos sensibles, relacionados con el estado de salud, antecedentes e historial clínico, información sobre modo
              de vida y otros datos necesarios o convenientes para los fines arriba señalados. Los datos personales sensibles serán mantenidos y
              tratados con estricta seguridad y confidencialidad para fines relacionados con la prestación de servicios de salud y conforme a este
              aviso de privacidad y la legislación, reglamentos y normativa aplicable.
            </span>

            <br />
            <br />
            <span class="d-block">
              <b>TRANSFERENCIA</b>
            </span>
            <span>
              Para la prestación de servicios
              <b>VISION LASER SAN LUIS</b> puede transferir dentro y fuera del país, los datos personales en su posesión
              a terceros subcontratados para fines relacionados con los señalados en este aviso de privacidad. Dentro de los terceros a los que se
              transferirán dichos datos se incluyen, de manera enunciativa, laboratorios, clínicas, hospitales, centros de investigación, aseguradoras,
              así como a cualquier empresa del mismo grupo corporativo, autoridades o aquellos que
              <b>VISION LASER SAN LUIS</b> considere necesario
              o conveniente comunicar datos personales.
            </span>

            <br />
            <br />
            <span class="d-block">
              <b>LIMITACIÓN DE USO Y DIVULGACIÓN DE DATOS PERSONALES</b>
            </span>
            <span>
              Para limitar el uso de sus datos personales, favor de notificar por escrito en
              <b>
                Av. Venustiano Carranza No. 2055, Col. Jardín, C.P.
                78270, San Luis Potosí, S.L.P,
              </b> o enviar un correo electrónico a
              <a
                href="mailto:info@lasersanluis.com.mx"
              >info@lasersanluis.com.mx</a> en el que se señale la limitación deseada
              al uso de sus datos.
            </span>

            <br />
            <br />
            <span class="d-block">
              <b>MEDIOS PARA EJERCER DERECHOS ARCO (ACCESO, RECTIFICACIÓN, CANCELACIÓN Y OPOSICIÓN)</b>
            </span>
            <span>
              Para tener acceso a los datos personales que
              <b>VISION LASER SAN LUIS</b> posee, así como para rectificarlos en caso de que éstos sean
              inexactos o incompletos, o para cancelarlos u oponerse a su tratamiento para ciertos fines, favor de presentar una solicitud por escrito,
              por medio del correo electrónico
              <a
                href="mailto:info@lasersanluis.com.mx"
              >info@lasersanluis.com.mx</a>, que contenga la siguiente información:
            </span>

            <ol type="a">
              <li>Nombre del titular.</li>

              <li>Domicilio de titular o dirección de correo electrónico para comunicar respuesta a solicitud.</li>

              <li>Documentos que acrediten identidad o autorización para representarlo en la solicitud.</li>
              <li>Descripción de datos personales sobre los que se pretende ejercer algún derecho ARCO.</li>
              <li>Cualquier otro elemento que permita la localización de los datos personales y atención a la solicitud.</li>
            </ol>

            <br />
            <span class="d-block">
              <b>MEDIOS PARA REVOCAR CONSENTIMIENTO</b>
            </span>
            <span>
              En cualquier momento puede solicitar la revocación del consentimiento otorgado a
              <b>VISION LASER SAN LUIS</b> para tratar sus datos
              personales enviando una solicitud por escrito, por medio del correo electrónico
              <a
                href="mailto:info@lasersanluis.com.mx"
              >info@lasersanluis.com.mx</a>, en la que se detalle
              claramente los datos respecto de los que revoca su consentimiento.
            </span>

            <br />
            <br />
            <span class="d-block">
              <b>NOTIFICACIÓN DE CAMBIOS AL AVISO DE PRIVACIDAD</b>
            </span>
            <span>
              El presente Aviso de Privacidad podrá ser modificado en cualquier momento para cumplir con actualizaciones legislativas,
              jurisprudenciales, políticas internas, nuevos requisitos para la prestación de servicios de
              <b>VISION LASER SAN LUIS</b> o cualquier otra
              causa a entera discreción de
              <b>VISION LASER SAN LUIS.</b> En tal caso, las modificaciones estarán disponibles en nuestra página de
              internet
              <a href="https://lasersanluis.com.mx/">www.lasersanluis.com.mx</a>
              <b>Av. Venustiano Carranza No. 2055, Col. Jardín, C.P. 18270, San Luis Potosí, S.L.P.</b>
            </span>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "AvisoPrivacidad",
  props: {
    visible: Boolean
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          return this.$emit("close");
        }
      }
    }
  }
};
</script>